import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";

const FontawesomeIconsDemo = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // Kunin ang lahat ng icon names mula sa @fortawesome/free-solid-svg-icons
  const iconList = Object.keys(Icons)
    .filter((key) => key.startsWith("fa"))
    .map((icon) => ({
      icon: Icons[icon],
      iconName: icon.replace("fa", "").toLowerCase(), // Simplified name (e.g., usershield)
      fullIconName: icon, // Full icon name (e.g., faUserShield)
    }));

  // I-filter ang mga icon base sa search term
  const filteredIcons = iconList.filter((icon) =>
    icon.iconName.includes(searchTerm.toLowerCase())
  );

  // Function para i-copy ang full icon name
  const copyIconName = (fullIconName) => {
    navigator.clipboard.writeText(fullIconName).then(() => {
      alert(`Copied: ${fullIconName}`);
    });
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>FontAwesome Free Solid Icons</h1>
      <input
        type="text"
        placeholder="Search icons (e.g., admin)"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          fontSize: "16px",
          marginBottom: "20px",
        }}
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gap: "20px",
        }}
      >
        {filteredIcons.map((icon, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => copyIconName(icon.fullIconName)} // Copy full icon name on click
          >
            <FontAwesomeIcon icon={icon.icon} size="2x" />
            <span style={{ marginTop: "10px", fontSize: "14px" }}>
              {icon.iconName} {/* Simplified name */}
            </span>
            <span style={{ marginTop: "5px", fontSize: "12px", color: "#666" }}>
              {icon.fullIconName} {/* Full icon name */}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FontawesomeIconsDemo;
